import styled from 'styled-components';
import { HTMLProps } from '@ch/common/utils';
import { colors } from '../../const/color';
import { GridBreakpointsMediaDown } from '../../const/grid';

export const FooterCopyrightStyled = styled.p`
  color: white;
  font-weight: 500;
  text-align: right;
  margin: 0 10px;

  ${GridBreakpointsMediaDown.lg} {
    text-align: center;
    margin-bottom: 20px;
  }
`;

const FooterStyled = styled.footer<{ $bgColor?: string }>`
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${colors.primary};
  z-index: 3;
  ${({ $bgColor }) =>
    $bgColor &&
    `
    background-color: ${$bgColor};
  `}
`;

export const FooterBlock = styled.div<HTMLProps<HTMLDivElement>>`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 15px 10px;
`;

export const FooterInner = styled.div<HTMLProps<HTMLDivElement>>`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default FooterStyled;
